/**
 * Service for Mercalink server API endpoints
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, pipe, take, catchError, of } from 'rxjs';

import * as dao from '../shared/dao';
import * as utils from '../shared/utils';
import * as constants from '../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class ApiclientService {

  constructor(private http: HttpClient) { }
  
	getFse$( server_url: string, id: number ): Observable<dao.FSEOrder[]> {
	  return this.http.get<dao.FSEOrder[]>(server_url + `/hc/fse/${id}`).pipe(
	    take(1),
	  );
	}
  
	getOrders$(server_url: string, id: number):Observable<any> {
	  return this.http.get<void>(server_url + `/sales/orders?q=id:${id}&o=lines`).pipe(take(1));
  }
  
	getProduct(server_url: string, template_id: number, datreflpp:string):Observable<dao.ApiResponse<any>> {
		datreflpp = utils.getCurrentDateISO (utils.fromFRformat(datreflpp));																		// Get datreflpp in ISO format
	  return this.http.get<dao.ApiResponse<any>>(server_url + `/hc/product?product_id=${template_id}&datreflpp=${datreflpp}`);
  }  
  
	getLpp$(server_url: string, id: number):Observable<any> {
	  return this.http.get<void>(server_url + `/hc/lpp/${id}`);
  }  
  
	getUser$(server_url: string, id: number):Observable<any> {
	  return this.http.get<void>(server_url + `/user/${id}`).pipe(take(1));
  }  
	
	getFseDoc$(server_url: string, id: string):Observable<any> {
	  return this.http.get<void>(server_url + `/hc/scor/${id}`).pipe(take(1));
	}  	
  
	postFseOrderEvent$(server_url: string, id: number, eventtyp: number, userid: number, data: any): Observable<any> {
	  let event:dao.Event = {
		  id: 0,
		  typ: eventtyp,			// 1: Insert, 2: Update
			userid: userid,
		  objectid: id,
		  objecttyp: constants.OBJECTTYP_HCORDER,			// Health Care Order (OBJECTTYP_HCORDER)
		  data: data,
	  }
	  return this.http.post<any>(server_url + "/event", event, { 'headers': dao.jsonheader });
  }  
	
	// Post patient data: INSERT / UPDATE_SPECIF
  // Used by save HC patient button on bs_dialog
	postFsePatientEvent$(server_url: string, eventtyp: number, userid: number, bsDTO: dao.BeneficiaireFact): Observable<any> {
	  let event:dao.Event = {
		  id: 0,
		  typ: eventtyp,			// 1: Insert, 2: Update
			userid: userid,
		  objectid: 0,
		  objecttyp: constants.OBJECTTYP_HCPATIENT,
		  data: bsDTO,
	  }
	  return this.http.post<any>(server_url + "/event", event, { 'headers': dao.jsonheader });
	}		  
	
	// Post card data INSERT=card inserted (create fse_patient occ.) UPDATE=set fse_patient.partner to customer
	postFseCardEvent$(server_url: string, eventtyp: number, userid: number, data: any): Observable<any> {
	  let event:dao.Event = {
		  id: 0,
		  typ: eventtyp,			// 1: Insert, 2: Update
			userid: userid,
		  objectid: 0,
		  objecttyp: constants.OBJECTTYP_HCCARD,
		  data: data,
	  }
	  return this.http.post<any>(server_url + "/event", event, { 'headers': dao.jsonheader });
	}			

  public getBarcodeScanapcv$(scanapcv_url: string) {                            // Get QR code ApCV token from scanner agent API
    return this.http.get<any>(`${scanapcv_url}/barcode/scanapcv`).pipe(take(1));
  }  

  public getNFCScanapcv$(scanapcv_url: string) {                            // Get NFC ApCV token from scanner agent API
    return this.http.get<any>(`${scanapcv_url}/nfc/scanapcv`).pipe(take(1));
  }    
	
	/*
	// Post HC patients (create fse_patient occ.) from hc card WARNING Duplicate from quotationService
	postHCCardEvent(server_url: string, eventtyp: number, userid: number, data: any): Observable<any> {	
		console.log("In postHCRecipientEvent");
		let event:dao.Event = {
			id: 0,
			typ: eventtyp,
			userid: userid,
			objectid: 0,
			objecttyp: constants.OBJECTTYP_HCCARD,
			data: data,
		}
		return this.http.post<any>(server_url + "/event", event, { 'headers': dao.jsonheader });
	}	
	*/	
}
